import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { IAgentPerformanceResponse } from '../interfaces/agent-performance.interface';

@Injectable({
    providedIn: 'root'
})
export class AgentPerformanceService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getAgentPerformance(flightDateSearch: string, beginDate: string, endDate: string): Observable<IAgentPerformanceResponse> {
        const apiUrl = `${this.baseUrl}/dashboard/agentPerformance`;

        let params = new HttpParams()
            .set('flightDateSearch', flightDateSearch.toString())
            .set('beginDate', beginDate)
            .set('endDate', endDate);

        return this.http.get<IAgentPerformanceResponse>(apiUrl, { params });
    }
}
